import axios from 'axios';
import { message } from 'antd';

// 获取后端基础地址
function getBackendBaseUrl() {
  // 优先使用全局配置（运行时注入）
  if (window.__APP_CONFIG__ && window.__APP_CONFIG__.API_URL) {
    return window.__APP_CONFIG__.API_URL;
  }
  
  // 使用环境变量（构建时注入）
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // 使用相对路径，让浏览器自动解析主机和端口
  return ''; // 空字符串表示相对于当前域名
}

// 获取后端API地址
function getApiBaseUrl() {
  return getBackendBaseUrl() + '/api/v1';
}

// 获取图片完整URL
function getImageUrl(fileUrl) {
  if (!fileUrl) return '';
  
  // 如果已经是完整的URL，直接返回
  if (fileUrl.startsWith('http://') || fileUrl.startsWith('https://')) {
    return fileUrl;
  }
  
  // 构建完整的图片URL，使用后端API地址
  const backendBaseUrl = getBackendBaseUrl();
  
  // 确保路径格式正确
  let normalizedUrl = fileUrl;
  if (!normalizedUrl.startsWith('/')) {
    normalizedUrl = '/' + normalizedUrl;
  }
  
  // 如果已经包含 /uploads 前缀，直接使用
  if (normalizedUrl.startsWith('/uploads')) {
    return backendBaseUrl + normalizedUrl;
  }
  
  // 否则，添加 /uploads 前缀
  return backendBaseUrl + '/uploads' + normalizedUrl;
}

// 创建axios实例
const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 300000,  // 增加到5分钟，用于处理大量图片上传
  headers: {
    'Content-Type': 'application/json',
  },
});

export { getImageUrl };

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Token过期，尝试刷新
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (refreshToken) {
          const response = await axios.post('/api/v1/auth/refresh', {
            refresh_token: refreshToken,
          });
          
          const { access_token } = response.data;
          localStorage.setItem('access_token', access_token);
          
          // 重试原请求
          originalRequest.headers.Authorization = `Bearer ${access_token}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        // 刷新失败，清除token并跳转登录
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    // 处理其他错误
    if (error.response?.status === 403) {
      message.error('权限不足');
    } else if (error.response?.status === 404) {
      message.error('资源不存在');
    } else if (error.response?.status >= 500) {
      message.error('服务器错误，请稍后重试');
    }

    return Promise.reject(error);
  }
);

export default api;
